export default "__VITE_ASSET__d75ef45d__"